<template>
  <div>
        <div class="header2 pc">
          <div class="inner">
            <p>
              <a href="https://www.jxrsrc.com/">
                <img src="@/assets/logo.png" />
              </a>
            </p>
            <p>
              <a href="https://jxrsrc.com/member/login/personal">个人登录</a>
              <a href="https://jxrsrc.com/member/login/company">单位登录</a>
            </p>
          </div>
        </div>
        <div style=" font-size:0px;"><img :src="banner" alt="" style="width: 100%;height:100%;display：block" /></div>
        <!-- 活动介绍 -->
        <div v-show="currentTab == 0" class="hph_back">
          <!-- <div class="cardBox3">
            <div
              style="
                width: 550px;
                height: 308px;
                margin: 0 auto;
                margin-top:50px
              "
            >
              <div>
                <AliPlayer
                  ref="videoPlayer"
                  :source="src[0]"
                  height="308px"
                  :cover="jxhimg"
                />
                <div
                  style="
                    text-align: center;
                    font-size: 0.36rem;
                    margin-top: 0.2rem;
                  "
                ></div>
              </div>
            </div>
          </div> -->
          <div class="btnBox">
            <el-button type="primary" @click="outLink(0)">引才单位端</el-button>
            <el-button type="primary" @click="outLink(1)">引才机构端</el-button>
            <el-popover
              placement="right-end"
              width=""
              trigger="click">
              <div style="text-align:center">
                <el-image :src="wx_qrcode" alt=""></el-image>
                <div>微信扫一扫</div>
              </div>
              <el-button slot="reference" type="primary" style="width:140px;height:50px">人才端</el-button>
            </el-popover>
          </div>

          

          <div class="row">
            <p style="color:#dedede">
              为更好地促进海外人才了解嘉兴、走进嘉兴、落户嘉兴，加快建设产才融合典范市、青创人才理想城、营智环境标杆地，嘉兴市人才交流服务中心打造海外引才数字化平台——“海聘汇”，依托该平台，我市将举办一系列“嘉人有约·海智嘉汇”海外高层次人才云聘会。主要功能如下：
            </p>
            <div class="row2">
              <div class="imgt">
                <span style="color:#dedede">一、引才单位端</span>
              </div>
            </div>
            <p style="color:#dedede">
              1.引才单位可在“海聘汇”平台发布本单位海外人才、高端人才需求岗位。
            </p>
            <p style="color:#dedede">
               2.引才单位可通过“海聘汇”平台，及时了解政府组织的海外云聘会信息，发布招聘信息，组织海外人才、高端人才报名，通过双向选择，实现精准对接。
            </p>
            <div class="row2">
              <div class="imgt">
                <span style="color:#dedede">二、引才机构端</span>
              </div>
            </div>
            <p style="color:#dedede">1.根据嘉兴市产业发展和引才需求情况，推荐海外人才、高端人才来嘉就业，促进海外人才、高端人才了解岗位、走进单位。</p>
            <p style="color:#dedede">2.通过“海聘汇”了解海外人才、高端人才在嘉就业情况、掌握人才去向，组织海外人才、高端人才走访考察引才单位。</p>
            <div class="row2">
              <div class="imgt">
                <span style="color:#dedede">三、人才端</span>
              </div>
            </div>
            <p style="color:#dedede">通过“海聘汇”了解嘉兴人才环境、引才单位和就业职位，一键掌握来嘉引才政策，随时投递简历。</p>
          </div>
        </div>
        <div class="foot3">
          <div style="margin-top: 100px;color:#fff">
            <p>
              嘉兴东方人才服务公司 版权所有Copyright © 1999-2022 CNCHR. All
              rights reserved.
            </p>
            <p>网站备案:浙ICP备14023938号-1</p>
            <p>公网安备:浙公网安备 33040202000321号</p>
          </div>
        </div>
  </div>
</template> 


<script>
/* eslint-disable */
import Vue from "vue";
import jxhimg from "@/assets/hdjs/jxh.jpg";
import banner from "@/assets/banner8.png";
import wx_qrcode from "@/assets/wx_qrcode2.jpg";
import back0 from "@/assets/back0.jpg";
import back1 from "@/assets/back1.jpg";
import AliPlayer from "../component/AliPlayer.vue";
import Header from "../component/header.vue";
import "@/icons/iconfont.js";
import jxh from "@/assets/hdjs/jxh.mp4";
// Vue.use(
//   VueVideoPlayer
// );
// Vue.use(Lazyload, {
//   loading: zhanwei,
// });

export default {
  name: "hph",
  components: { AliPlayer,Header },
  data() {
    return {
      src: [jxh],
      banner,
      jxhimg,
      wx_qrcode,
      back1,
      back0,
      currentTab: 0,
    };
  },
  watch: {
  },
  created() {
    window.document.titie = '海聘汇'
  },
  mounted() {
   
  },
  computed: {},
  beforeDestroy() {
    // if (this.player) {
    //   this.player.dispose();
    // }
  },
  methods: {
    outLink(n){
      if(n==0){
        window.open('http://zhaopin.yrdtalent.com/Company/Login/index.html','_blank')
      }
      else if(n==1){
        window.open('http://zhaopin.yrdtalent.com/Organization/Login/index.html','_blank')
      }
    },
    toSignUp(n) {
        window.open(n,'_blank')
    }
  },
};
</script>
<style>
.hph_back{
  background-image: url(../../assets/back0.jpg);
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.header2 {
  display: flex;
  justify-content: center;
  background-color: #fff;
}
.header2 .inner {
  display: flex;
  justify-content: space-between;
  width: 2500px;
  padding: 15px 0;
  margin: 0 auto;
}
.header2 p {
  display: flex;
}
.header2 p a {
  display: flex;
  height: 40px;
}
.header2 p a img {
  width: auto;
  height: 40px;
}
.header2 p {
  display: flex;
}
.header2 p + p a {
  padding: 0 15px 0 12px;
  background-color: #f2f2f2;
  font-size: 14px;
  color: #333;
  line-height: 40px;
}
.header2 p + p a:nth-child(1):before {
  background: url(http://dlo.jxrsrc.com/zph2022/20220318/img/user_ico01.png)
    no-repeat center;
}
.header2 p + p a:nth-child(2):before {
  background: url(http://dlo.jxrsrc.com/zph2022/20220318/img/user_ico02.png)
    no-repeat center;
}
.header2 p + p a:before {
  content: "";
  display: flex;
  width: 16px;
  height: 16px;
  margin: 12px 8px 12px 0;
}
.container {
  width: 100%;
  background: #f4f4f4;
}
.container {
  width: 100%;
  background: #f4f4f4;
}
.navigation {
  text-align: center;
  color: #000;
}
ul#nav1 {
  width: 100%;
  height: 80px;
  background: #fff;
  margin: 0 auto;
}
ol,
ul {
  list-style: none;
}
ul#nav1 li {
  margin: 0 -3px;
  display: inline;
  height: 80px;
}
ul#nav1 li a {
  display: inline-block;
  padding: 0 130px;
  height: 80px;
  line-height: 80px;
  color: #3fcfea;
  font-family: "\5FAE\8F6F\96C5\9ED1";
  font-size: 30px;
  text-decoration: none;
  font-weight: 700;
  cursor: pointer;
}
.navigation ul#nav1 li a.active,
.navigation ul#nav1 li a:hover {
  color: #fff;
  background: #3fcfea;
}

.row {
  width: 100%;
  max-width: 1600px;
  min-width: 755px;
  margin: 0 auto;
  overflow: hidden;
  text-align: left;
}
.row2 {
  max-width: 1260px;
  min-width: 755px;
  margin: 0 auto;
  /* overflow: hidden; */
  text-align: center;
}
.row2 .imgt {
  margin: 1rem 0;
  font-size: 30px;
}
.row2 .imgt img {
  margin-bottom: -10px;
}
.row2 .imgt span {
  color: #000;
  font-weight: 700;
}
.row2 .imgc {
  margin: 0 auto;
  width: 400px;
  height: 114px;
  background: url(../../assets/hdjs/101b2ff9.png) no-repeat 50%;
  text-align: center;
  font-family: Courier New, Courier, monospace;
  font-size: 30px;
  font-weight: 700;
  line-height: 58px;
  color: #fff;
  padding-top: 30px;
  margin-top: 80px;
  margin-bottom: 30px;
}
.row2 .video {
  max-width: 960px;
  min-width: 395px;
  margin: 0 auto;
  padding-top: 22px;
  padding-bottom: 120px;
}
.row p {
  line-height: 40px;
  padding: 0 30px;
  text-indent: 40px;
  font-size: 18px;
  font-family: Microsoft YaHei !important;
  color: #000;
}
.tableWidth p{
  text-indent: 0px;
}
.btnBox {
  display: grid;
  grid-template-columns: repeat(3, 150px);
  grid-template-rows: repeat(1, 50px);
  grid-row-gap: 100px;
  grid-column-gap: 100px;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  padding-top: 60px;
  padding-bottom: 60px;
}
.videoBox .video {
  max-width: 350px;
  margin: 0 auto;
  padding-top: 22px;
  /* padding-bottom: 120px; */
  /* padding-bottom: 50px; */
}
.wrap-4-wrap {
  /* margin: 0 0 .1rem; */
  width: 1200px;
  margin: 0 auto;
  margin-top: 50px;
}
.el-tabs--border-card {
  background: #fff;
  border: 1px solid #dcdfe6;
  -webkit-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12),
    0 0 6px 0 rgba(0, 0, 0, 0.04);
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
  /* height: 838px; */
}
.el-tabs--border-card > .el-tabs__content {
  padding: 15px;
}
.el-tabs__content {
  overflow: hidden;
  position: relative;
}
.wrap-4-wrap .el-tab-pane {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -ms-flex-pack: distribute;
  justify-content: space-between;
}
.wrap-4-wrap .el-tab-pane {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -ms-flex-pack: distribute;
}
.wrap-4-wrap .wrap-list {
  width: 575px;
  padding: 0.1rem;
  margin-right: 0.1rem;
  margin-bottom: 0.5rem;
  overflow: hidden;
  font-size: 0.3rem;
  border: 1px solid #6aafb7;
  background-color: #fff;
}
.wrap_list_new {
  background-color: #fff !important;
}
.wrap-4-wrap .wrap-list .enter-title {
  color: #3a3a3a;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.wrap-4-wrap .wrap-list .enter-name {
  /* width: 230px; */
  width: 100%;
  margin-left: 0.3rem;
  position: relative;
  color: #909090;
}
.enter_online_w {
  position: relative;
}
.wrap-4-wrap .wrap-list .enter-name .enter-name-list-title {
  font-size: 0.35rem;
  color: #6aafb7;
  font-weight: 600;
  height: 25px;
  width: 100%;
}
.wrap-4-wrap .wrap-list .enter-name .enter-name-list {
  margin-bottom: 0.1rem;
  font-size: 16px;
}
.wrap-4-wrap .wrap-list .enter-name .five-list {
  width: 50%;
  float: left;
}
.wrap-4-wrap .wrap-list .enter-detail {
  color: #909090;
  height: 250px;
  position: relative;
}
.wrap-4-wrap .wrap-list .enter-data {
  padding: 0.3125rem;
  padding-bottom: 0.5rem;
}
.wrap-4-wrap .wrap-list .enter-jobs {
  border: 0.0625rem solid #4fa9f6;
  width: 6rem;
  line-height: 3;
  margin: 0 auto;
  text-align: center;
  font-size: 0.3rem;
  font-weight: 700;
  color: #4fa9f6;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  cursor: pointer;
}
.wrap_list_new .enter-jobs {
  -webkit-box-shadow: 0 3px 3px #e5e5e5;
  box-shadow: 0 3px 3px #e5e5e5;
  background-color: #4fa9f6;
  color: #fff !important;
}
.wrap-4-wrap .wrap-list .enter-name .five-list {
  width: 1000%;
  float: left;
  text-align: left;
}
.red-header {
  z-index: 100;
}
.header {
  position: absolute;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 70px;
  font-size: 16px;
  font-family: PingFang SC, Helvetica, Arial, sans-serif;
  font-weight: 500;
  min-width: 1350px;
}
.header .navigation-bar {
  list-style-type: none;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  margin: 0 76px 0 0;
  padding: 0;
  min-width: 1080px;
  width: 100%;
}
.dark-theme .navigation-bar .active {
  color: #000;
}
.header .navigation-bar .active {
  margin-left: 58px;
}
.active {
  text-decoration: none;
}
.dark-theme .navigation-bar .navigation-item {
  position: relative;
}
.header .navigation-bar .navigation-item {
  cursor: pointer;
  margin: 0;
}
.dark-theme .navigation-bar .current-tab:before {
  visibility: visible;
  transform: translateX(0);
  opacity: 1;
}
.dark-theme .navigation-bar .navigation-item:before {
  position: absolute;
  bottom: -10px;
  visibility: hidden;
  content: "";
  width: 100%;
  height: 2px;
  background-color: hsla(0, 0%, 100%, 0.5);
  transform: translateX(-100%);
  border-radius: 2px;
  opacity: 0;
}
.el-header {
  padding: 0 !important;
}
.header .logo {
  height: 25px;
  margin-left: 91px;
  display: flex;
  align-items: center;
}
.header .logo .logo2 {
  cursor: pointer;
  margin-top: 1px;
  width: 150px;
  height: 62px;
  position: relative;
}
.header .logo .logo2 img {
  position: absolute;
  width: 100%;
  height: 100%;
}
.banner2 {
  width: 100%;
  height: 100%;
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: cover;
  /* background-image: url(../../assets/banner2.png); */
  /* box-shadow: 0 16px 36px 4px rgba(255, 255, 255, .7); */
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #6aafb7 !important;
}
.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li:hover {
  color: #6aafb7 !important;
}
.el-pagination.is-background .el-pager li:not(.disabled).active:hover {
  color: #fff !important;
}
.outline {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  padding-top: 1rem;
}
.item-wrapper {
  width: 940px;
  height: 198px;
  flex-direction: row;
  background-color: #fff;
  margin: 0 0 58px;
  cursor: pointer;
}
.item-wrapper,
.outline {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.item-wrapper .image-wrapper {
  height: 100%;
}
.item-wrapper .image-wrapper .image {
  width: 310px;
  height: 100%;
  object-fit: cover;
}
.item-wrapper .item {
  margin: 0 0 0 36px;
  padding-right: 30px;
  height: 189px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}
.item-wrapper .item .title-wrapper {
  margin: 10px 0 0;
  font-size: 20px;
  color: #000;
}
.item-wrapper .item .content {
  color: #666;
  line-height: 24px;
  width: 581px;
  /* height: 48px; */
  overflow: hidden;
  text-align: left;
  font-size: 15px;
  margin-top: 0.3rem;
}
.foot3 {
  height: 212px;
  background-image: url(../../assets/footer3.jpg);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  text-align: center;
  font-size: 12px;
  color: #000;
  padding: 15px;
  font-size: 16px;
  /* background-color: rgb(243, 243, 243); */
}
.foot p {
  line-height: 25px;
}
.el-footer {
  padding: 0 !important;
}
.el-container {
  background-image: url(../../assets/back1.jpg);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-color: rgb(243, 243, 243);
}
.cardBox {
  display: grid;
  grid-template-columns: repeat(2, 500px);
  grid-template-rows: repeat(1, 250px);
  grid-row-gap: 100px;
  grid-column-gap: 100px;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  padding-bottom: 120px;
}
.cardBox2 {
  display: grid;
  grid-template-columns: repeat(2, 550px);
  grid-template-rows: repeat(1, 308px);
  grid-row-gap: 100px;
  grid-column-gap: 100px;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}
.cardBox3 {
  display: grid;
  grid-template-columns: repeat(1, 500px);
  grid-template-rows: repeat(1, 300px);
  grid-row-gap: 100px;
  grid-column-gap: 100px;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  padding-bottom: 120px;
}
.cardBox4 {
  display: grid;
  grid-template-columns: repeat(1, 500px);
  grid-template-rows: repeat(1, 200px);
  grid-row-gap: 100px;
  grid-column-gap: 100px;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  padding-bottom: 60px;
}
.cardBox .box-card {
  max-width: 500px;
  margin: 0 auto;
  padding-top: 22px;
}
.box-card {
  width: 480px;
}
.text {
  font-size: 16px;
  text-align: left;
  text-indent: 30px;
  line-height: 28px;
}
.text2 {
  font-size: 16px;
  text-align: left;
  line-height: 28px;
}
.item {
  margin-bottom: 18px;
}
.main2 {
  display: flex;
  flex-direction: column;
  align-items: center;
  /* margin: 60px auto; */
}
.main2 .section {
  display: flex;
  flex-direction: column;
  width: 1200px;
}
.web .list2 {
  display: flex;
  flex-direction: column;
}
.web .list2 ul {
  display: flex;
  flex-wrap: wrap;
}
.line2 {
  width: 100%;
  height: 1px;
  /* border-top: 1px solid #FDC236; */
  text-align: center;
  margin: 50px 0px;
  /* margin-top: 50px; */
  display: none;
}
.line2 span {
  position: relative;
  top: -12px;
  /* background: #F2FBF6; */
  padding: 0 10px;
  font-size: 20px;
  font-weight: 800;
  margin: 0 auto;
}
.web .list2 li {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 250px;
  padding: 10px 20px;
  border-radius: 10px;
  margin-right: 24px;
  margin-bottom: 24px;
  background-color: #fff;
}
.web .list2 li .firm {
  display: flex;
  flex-direction: column;
}
.web .list2 li .firm a {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0 20px;
}
.web .list2 li .firm a:hover {
  cursor:pointer
}
.web .list2 li .firm a p {
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
}
.web .list2 li .firm a p b {
  margin: 20px 0 12px;
  max-width: 242px;
  font-size: 16px;
  color: #333;
  line-height: 18px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.web .list2 li .firm a p span {
  font-size: 14px;
  color: #999;
  line-height: 14px;
}
.jobs2 {
  text-indent: 32px;
  font-size: 16px;
  line-height: 25px;
  /* display: flex;
  flex-direction: column; */
  height: 70px;
  display:-webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
}
.jobs{
  display: flex;
  flex-direction: column;
  min-height: 90px;
}
.web .list2 li .jobs a {
  display: flex;
  justify-content: space-between;
  height: 30px;
  padding: 0 5px;
  border-radius: 5px;
  font-size: 15px;
  line-height: 30px;
}
.web .list2 li .jobs a span {
  max-width: 250px;
  color: #333;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.web .list2 li .btns {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 20px 0;
}
.web .list2 li .btns a {
  display: flex;
  padding-right: 15px;
  /* background: url(../img/more_hover.png) no-repeat right; */
  font-size: 13px;
  color: #888;
  line-height: 13px;
}
.web .list2 li .btns a {
  cursor:pointer
}
.tableWidth {
  width: 1200px;
  margin: 0 auto;
}
.box-wrap {
  display: flex;
  flex-wrap: wrap;
  justify-content: normal;
  margin-left: 55px;
}
.sch_logo{
  padding-top: 30px;
  /* width: 100%;
  height: 100%; */
}
.image-slot{
  height: 100px;
}
.sch_logo img{
  width: 80%;
  /* height: 100%; */
}
@media all and (max-width: 767px) {
  .web .list2 li {
    width: 350px;
  }
  .main2 .section {
    width: 800px;
  }
  .tableWidth {
    width: 600px;
  }
  .cardBox {
    display: grid;
    grid-template-columns: repeat(2, 400px);
    grid-template-rows: repeat(1, 250px);
    grid-row-gap: 100px;
    grid-column-gap: 50px;
    justify-content: center;
    padding-bottom: 120px;
  }
  .cardBox .box-card {
    max-width: 400px;
    margin: 0 auto;
    padding-top: 22px;
  }
  .cardBox2 {
    display: grid;
    grid-template-columns: repeat(1, 550px);
    grid-template-rows: repeat(1, 308px);
    grid-row-gap: 100px;
    grid-column-gap: 100px;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
  }
  .el-header {
    height: 395px !important;
  }
  .navigation ul#nav1 li a {
    padding: 0 10px;
  }
  .videoBox {
    display: grid;
    grid-template-columns: repeat(2, 350px);
    grid-template-rows: repeat(9, 250px);
    grid-row-gap: 100px;
    grid-column-gap: 100px;
    justify-content: center;
    padding-bottom: 120px;
  }
}
@media all and (min-width: 768px) and (max-width: 1170px) {
  .box-wrap {
    margin-left: 20px;
  }
  .web .list2 li {
    width: 350px;
  }
  .main2 .section {
    width: 800px;
  }
  .tableWidth {
    width: 900px;
  }
  .cardBox {
    display: grid;
    grid-template-columns: repeat(2, 400px);
    grid-template-rows: repeat(1, 250px);
    grid-row-gap: 100px;
    grid-column-gap: 50px;
    justify-content: center;
    padding-bottom: 120px;
  }
  .cardBox .box-card {
    max-width: 400px;
    margin: 0 auto;
    padding-top: 22px;
  }
  .cardBox2 {
    display: grid;
    grid-template-columns: repeat(1, 550px);
    grid-template-rows: repeat(1, 308px);
    grid-row-gap: 100px;
    grid-column-gap: 100px;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
  }
  .videoBox {
    display: grid;
    grid-template-columns: repeat(2, 350px);
    grid-template-rows: repeat(9, 250px);
    grid-row-gap: 100px;
    grid-column-gap: 100px;
    justify-content: center;
    padding-bottom: 120px;
  }
  .el-header {
    height: 395px !important;
  }
  .navigation ul#nav1 li a {
    padding: 0 30px;
  }
}

@media all and (min-width: 1171px) and (max-width: 1570px) {
  .box-wrap {
    margin-left: 0px;
  }
  .main2 .section {
    width: 1100px;
  }
  .tableWidth {
    width: 1000px;
  }
  .navigation ul#nav1 li a {
    padding: 0 80px;
  }
  .el-header {
    height: 500px !important;
  }
}
@media all and (min-width: 1571px) and (max-width: 1990px) {
  .navigation ul#nav1 li a {
    padding: 0 80px;
  }
  .el-header {
    height: 610px !important;
  }
}
@media all and (min-width: 1991px) and (max-width: 2200px) {
  .el-header {
    height: 650px !important;
  }
}
</style>
